module.exports = __webpack_public_path__ + "static/media/Salir(A).37e5d668.svg";